import React from "react";
import { Area, AreaChart, CartesianGrid, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";

const fmt = (n) => Number(n || 0).toLocaleString("es-VE", { maximumFractionDigits: 1 });

export const PlayerMetrics = ({ metrics }) => {
  if (!metrics) return <p className="text-sm text-slate-500">Sin métricas disponibles.</p>;
  const t = metrics.totals;
  const tiles = [
    ["Horas ahorradas", fmt(t.hours_saved)],
    [`${t.currency || "USD"} ahorrados`, `${t.currency || "USD"} ${fmt(t.usd_saved)}`], // fix 12b: real currency
    ["Interacciones", fmt(t.chats)],
    ["Tareas completadas", fmt(t.tasks_completed)],
    ["Tasa de éxito", `${fmt(t.success_rate_pct)}%`],
    ["CSAT", `${fmt(t.csat_pct)}%`],
  ];
  return (
    <section data-testid="player-step-metrics">
      <p className="text-[11px] uppercase tracking-[0.18em] text-slate-500">{metrics.agent_name} · últimos 6 meses</p>
      <div className="mt-4 grid grid-cols-2 gap-px bg-slate-200 md:grid-cols-3 lg:grid-cols-6" data-testid="player-kpi-tiles">
        {tiles.map(([k, v]) => (
          <div key={k} className="bg-white p-5">
            <p className="font-display text-2xl font-semibold text-slate-900">{v}</p>
            <p className="mt-1 text-[10px] uppercase tracking-[0.18em] text-slate-500">{k}</p>
          </div>
        ))}
      </div>
      <div className="mt-6 grid gap-6 lg:grid-cols-3">
        <div className="h-64 border border-slate-200 bg-white p-4 lg:col-span-2">
          <p className="mb-2 text-[10px] uppercase tracking-[0.18em] text-slate-500">Interacciones por mes</p>
          <ResponsiveContainer width="100%" height="90%" initialDimension={{ width: 320, height: 200 }}>
            <AreaChart data={metrics.trend}>
              <CartesianGrid strokeDasharray="3 3" stroke="#e2e8f0" />
              <XAxis dataKey="month" tick={{ fontSize: 11 }} />
              <YAxis tick={{ fontSize: 11 }} />
              <Tooltip />
              <Area type="monotone" dataKey="chats" stroke="#4F6BFF" fill="#4F6BFF" fillOpacity={0.15} name="Interacciones" />
            </AreaChart>
          </ResponsiveContainer>
        </div>
        <div className="border border-slate-200 bg-white p-4">
          <p className="text-[10px] uppercase tracking-[0.18em] text-slate-500">Iniciadores más usados</p>
          <ul className="mt-3 space-y-2">
            {metrics.top_prompts.slice(0, 5).map((p) => (
              <li key={p.prompt_id} className="flex justify-between gap-3 text-sm">
                <span className="text-slate-700">{p.title}</span>
                <span className="font-semibold text-slate-900">{p.count}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
};
